"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardBase = void 0;

var _stylitas = require("@creditas/stylitas");

const cardBase = props => (0, _stylitas.css)`
  ${_stylitas.utilities.surface.surface(props)};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 16px;
`;

exports.cardBase = cardBase;